import { commAxiosRequest } from "zr-util/src/utils/comm/commAxiosRequest";
import settingHelp from "@/config/localSetting";
const config = settingHelp.getConfig();
const { remoteURL, successCode, forceReLoginCode } = config;
import store from "@/store";
import router from "@/router";

function requestInterceptor(config) {
  const token = store.getters["user/accessToken"];
  if (token) {
    config.headers["Authorization"] = `${token}`;
  }
}

function responseInterceptor(response) {
  const { data, config } = response;
  let { code, msg } = data;
  if (
    forceReLoginCode.some((value) => {
      return value == code;
    })
  ) {
    store.dispatch("user/logout");
    router.push("/login");
  }
}

let remoteRequest = commAxiosRequest(
  {
    baseURL: remoteURL,
    timeout: 10000,
  },
  requestInterceptor,
  responseInterceptor,
  { successCode: successCode }
);

// export default remoteRequest;

export function request(opt) {
  return remoteRequest(opt);
}

export function resetRemoteRequest() {
  const newConfig = settingHelp.getConfig();
  const { remoteURL, successCode } = newConfig;
  remoteRequest = commAxiosRequest(
    {
      baseURL: remoteURL,
      timeout: 10000,
    },
    requestInterceptor,
    responseInterceptor,
    { successCode: successCode }
  );
}
